import React, { useState, useEffect } from 'react';
import '../styles/spot.css';

function Spot() {
    const [tradingPairs, setTradingPairs] = useState([]);
    const [spotAssets, setSpotAssets] = useState([]);
    const [spotHistory, setSpotHistory] = useState([]); // State for Spot History
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('SPOT MARKET'); // Track active tab

    useEffect(() => {
        const fetchSpotData = async () => {
            try {
                setIsLoading(true);
                setError(null);

                // Fetch trading pairs data
                const response = await fetch(
                    'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=cardano,avalanche-2,bitcoin,dogecoin&order=market_cap_desc&per_page=4&page=1'
                );
                if (!response.ok) {
                    throw new Error(`Failed to fetch data: ${response.status}`);
                }
                const data = await response.json();

                const formattedData = data.map(coin => ({
                    pair: coin.symbol.toUpperCase() + 'USD',
                    icon: coin.image,
                    lastPrice: coin.current_price.toFixed(5),
                    change: coin.price_change_percentage_24h.toFixed(2) + '%',
                }));

                setTradingPairs(formattedData);

                // Fetch spot assets data (mock data for example)
                const assetsData = [
                    { symbol: 'BTC', quantity: 0.5 },
                    { symbol: 'ETH', quantity: 2.3 },
                    { symbol: 'ADA', quantity: 100 },
                    { symbol: 'DOGE', quantity: 5000 },
                ];
                setSpotAssets(assetsData);

                // Fetch spot history data (mock data for example)
                const historyData = [
                    { date: '2023-10-01', action: 'Buy', symbol: 'BTC', quantity: 0.1, price: 25000 },
                    { date: '2023-10-02', action: 'Sell', symbol: 'ETH', quantity: 1, price: 1500 },
                    { date: '2023-10-03', action: 'Buy', symbol: 'ADA', quantity: 100, price: 0.25 },
                    { date: '2023-10-04', action: 'Sell', symbol: 'DOGE', quantity: 5000, price: 0.07 },
                ];
                setSpotHistory(historyData);
            } catch (error) {
                console.error('Fetch error:', error.message);
                setError(`Failed to load data. Please try again later.`);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSpotData();
        const interval = setInterval(fetchSpotData, 60000);
        return () => clearInterval(interval);
    }, []);

    if (isLoading) return <div className="spot-page">Loading...</div>;
    if (error) return <div className="spot-page">Error: {error}</div>;

    return (
        <div className="spot-page">
            <div className="spot-content">
                {/* Total Balance Section */}
                <div className="total-balance">
                    <h2>Total Balance</h2>
                    <div className="balance-info">
                        <span className="balance-hidden">*******</span>
                        <span className="info-icon">ℹ️</span>
                    </div>
                </div>

                {/* Allocation Section */}
                <div className="allocation">
                    <h2>ALLOCATION</h2>
                </div>

                {/* Tabs */}
                <div className="spot-tabs">
                    <button
                        className={`tab ${activeTab === 'SPOT MARKET' ? 'active' : ''}`}
                        onClick={() => setActiveTab('SPOT MARKET')}
                    >
                        SPOT MARKET
                    </button>
                    <button
                        className={`tab ${activeTab === 'SPOT ASSETS' ? 'active' : ''}`}
                        onClick={() => setActiveTab('SPOT ASSETS')}
                    >
                        SPOT ASSETS
                    </button>
                    <button
                        className={`tab ${activeTab === 'SPOT HISTORY' ? 'active' : ''}`}
                        onClick={() => setActiveTab('SPOT HISTORY')}
                    >
                        SPOT HISTORY
                    </button>
                </div>

                {/* Conditional Rendering Based on Active Tab */}
                {activeTab === 'SPOT MARKET' && (
                    <div className="spot-table">
                        <div className="table-header">
                            <span>Pair</span>
                            <span>Last Price</span>
                            <span>Action</span>
                        </div>
                        {tradingPairs.map((pair, index) => (
                            <div key={index} className="table-row">
                                <div className="pair-info">
                                    <img src={pair.icon} alt={pair.pair} className="pair-icon" />
                                    <span>{pair.pair}</span>
                                </div>
                                <div className="last-price">
                                    <span>{pair.lastPrice}</span>
                                    <span className={`change ${parseFloat(pair.change) >= 0 ? 'positive' : 'negative'}`}>
                                        {pair.change}
                                    </span>
                                </div>
                                <button className="trade-btn">TRADE</button>
                            </div>
                        ))}
                    </div>
                )}

                {activeTab === 'SPOT ASSETS' && (
                    <div className="spot-table">
                        <div className="table-header">
                            <span>Symbol</span>
                            <span>Quantity</span>
                        </div>
                        {spotAssets.map((asset, index) => (
                            <div key={index} className="table-row">
                                <div className="pair-info">
                                    <span>{asset.symbol}</span>
                                </div>
                                <div className="last-price">
                                    <span>{asset.quantity}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {activeTab === 'SPOT HISTORY' && (
                    <div className="spot-table">
                        <div className="table-header">
                            <span>Date</span>
                            <span>Action</span>
                            <span>Symbol</span>
                            <span>Quantity</span>
                            <span>Price</span>
                        </div>
                        {spotHistory.map((history, index) => (
                            <div key={index} className="table-row">
                                <div className="pair-info">
                                    <span>{history.date}</span>
                                </div>
                                <div className="last-price">
                                    <span>{history.action}</span>
                                </div>
                                <div className="last-price">
                                    <span>{history.symbol}</span>
                                </div>
                                <div className="last-price">
                                    <span>{history.quantity}</span>
                                </div>
                                <div className="last-price">
                                    <span>${history.price}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Spot;